






















import CollapsiblePanel from "../../core/UI/CollapsiblePanel.vue";
import FactureRow from "./FactureRow.vue";
import { RelanceApi } from "../../api/RelanceApi";
import { Contact } from "../../models/Contact";
import { Relance } from "../../models/Relance";

export default {
    name: "CoproprieteAccordion",
    components: { FactureRow, CollapsiblePanel },
    props: {
        copropriete: String,
        factures: Array,
    },
    data() {
        return {
            RelanceApi: new RelanceApi(),
        };
    },
    methods: {
        totalCopropriete(factures: Array<any>): number {
            const total = _.sumBy(factures, "montant");
            return _.round(total, 2).toFixed(2);
        },
        async onClientAssigned(event: { facture: Relance; client: Contact }) {
            try {
                // Update the relance with the assigned client
                const updatedRelance = await this.RelanceApi.update(
                    event.facture.id,
                    event.facture
                );

                // Emit event to parent component to refresh data if needed
                this.$emit("relance-updated", updatedRelance);

                // Show success message (you might want to use a toast notification system)
                console.log("Client assigné avec succès:", event.client.nom);
            } catch (error) {
                console.error("Erreur lors de l'assignation du client:", error);
                // You might want to show an error message to the user
                // and revert the local changes
                event.facture.copropriete = undefined;
            }
        },
    },
};
